import {Helmet} from "react-helmet";
import {RouteHelper} from "../../../route/RouteHelper";
import {
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoDefaultDialogPage,
    RaikoDivider,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoLabel,
    RaikoLabelType,
    RaikoSectionContainer,
    RaikoTree,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import RaikoBaseDialogContentContainer
    from "../../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";
import {TourismCategoryService} from "../../../serverService/tourism/TourismCategoryService";
import {LanguageHelper} from "../../../util/LanguageHelper";
import LanguageSelector from "../../../component/languageSelector/LanguageSelector";
import {CategoryParser} from "./CategoryParser";
import TourismCategoryDetail from "./TourismCategoryDetail";
import {useDebounce} from "@uidotdev/usehooks";

export default function TourismCategory() {


    const [parentItems, setParentItems] = useState([])
    const [baseCategoryItems, setBaseCategoryItems] = useState([])

    const service = new TourismCategoryService()
    const [baseCategoryLoading, setBaseCategoryLoading] = useState(false)

    const [languageId, setLanguageId] = useState()

    const [categoryItemsBySelectedLanguage, setCategoryItemsBySelectedLanguage] = useState([])
    const [selectedCategory, setSelectedCategory] = useState(-1)
    const selectedCategoryDebounce = useDebounce(selectedCategory,100);

    useEffect(() => {
        if (typeof service !== "undefined") {
            service.getCategoryListByLanguage(
                LanguageHelper.DEFAULT_LANGUAGE
            ).then(response => {
                const categoryParser = new CategoryParser(response);
                setParentItems(categoryParser.getCategoryListInlineParser())
                setBaseCategoryItems(categoryParser.getCategoryListParsed())
            }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {

            })
        }
    }, [])


    useEffect(() => {
        if (selectedCategoryDebounce && selectedCategoryDebounce !== -1){
            handleOpenDialog()
        }
    }, [selectedCategoryDebounce]);

    function getSelectedCategories(_languageCode) {
        if (_languageCode)
            service.getCategoryListByLanguage(_languageCode)
                .then(response => {
                    setCategoryItemsBySelectedLanguage(new CategoryParser(response).getCategoryListParsed())
                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {

            })
    }


    const [openDialog, setOpenDialog] = useState(false)
    const handleOpenDialog = () => setOpenDialog(true)
    const handleCloseDialog = () => {
        setOpenDialog(false)
        setSelectedCategory(-1)
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.TourismCategory.name}</title>
            </Helmet>

            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                hasCloseButton={false}
            >
                <TourismCategoryDetail
                    parentItems={parentItems}
                    categoryId={selectedCategoryDebounce}
                    handleCloseDialog={handleCloseDialog}
                    selectedLanguage={languageId}
                />
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Tourism.name,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.TourismCategory.name,
                                ""
                            ),
                        ]}/>
                    <LanguageSelector
                        setLanguageId={setLanguageId}
                        languageId={languageId}
                        handleGetInfo={getSelectedCategories}
                    />
                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"دسته بندی ها"}
                            subTitle={"مشاهده و ویرایش دسته بندی ها"}
                            hasHelperButton
                            helperTitle={"راهنمای مشاهده و ویرایش دسته بندی ها"}
                            helperContent={
                                <RaikoBaseDialogContentContainer>
                                    <RaikoGridOneColumn>
                                        <RaikoLabel
                                            text={`⚠️ امکان افزودن دسته بندی جدید فقط در حالت زبان فارسی وجود دارد.`}/>
                                        <RaikoLabel
                                            text={`برای افزودن دسته بندی جدید بعد از وارد کردن اطلاعات لازم بر روی دکمه ی افزودن کلیک نمایید.`}/>
                                        <RaikoLabel
                                            text={`برای ویرایش دسته بندی های کافی است دسته بندی مورد نظر را انتخاب کرده و بعد از اصلاح جزئیات بر روی بروزرسانی کلیک نمایید.`}/>
                                    </RaikoGridOneColumn>
                                </RaikoBaseDialogContentContainer>
                            }
                            hasActionButton
                            actionButtonTitle={"افزودن"}
                            actionButtonOnclick={handleOpenDialog}
                        >
                            <RaikoGridTwoColumn>
                                <RaikoGridOneColumn className={css`height: fit-content`}>
                                    <RaikoLabel raikoLabelType={RaikoLabelType.TITLE} text={" قابل ویرایش  🡣 "}/>
                                    <RaikoDivider/>
                                    <RaikoTree
                                        treeItems={categoryItemsBySelectedLanguage}
                                        selectedItemsId={[]}
                                        handleItemClicked={id => {
                                            setSelectedCategory(id)
                                        }}
                                    />
                                </RaikoGridOneColumn>

                                <RaikoGridOneColumn className={css`height: fit-content`}>
                                    <RaikoLabel raikoLabelType={RaikoLabelType.TITLE} text={" پیش نمایش  🡣 "}/>
                                    <RaikoDivider/>
                                    <RaikoTree
                                        treeItems={baseCategoryItems}
                                        selectedItemsId={[-1]}
                                        disabled
                                    />
                                </RaikoGridOneColumn>
                            </RaikoGridTwoColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}